import React, {Component} from 'react';

import { Tooltip } from "@mui/material";
import button from "bootstrap/js/src/button";

import Loading from "../../../component/loading/Loading";
import MessageDetailModal from "../component/modal/MessageDetailModal";
import MessageTestModal from "../component/modal/MessageTestModal";

import * as apiUtil from '../../../util/apiUtil';
import * as stringUtil from '../../../util/stringUtil';
import * as messageUtil from '../../../util/messageUtil';
import * as dateUtil from "../../../util/dateUtil";

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as sentMessageAction from "../store/sentMessage";

class SentDetailContainer extends Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);
        this.downloadFile = this.downloadFile.bind(this);

        this.ajaxGetSentMessage = this.ajaxGetSentMessage.bind(this);
        this.ajaxCancelMessage = this.ajaxCancelMessage.bind(this);
        this.ajaxRefundMessage = this.ajaxRefundMessage.bind(this);
        this.ajaxUpdateDeleteFlag = this.ajaxUpdateDeleteFlag.bind(this);
        this.ajaxCancelMessageForPackageCmpn = this.ajaxCancelMessageForPackageCmpn.bind(this);

        this.handleDetailModal = this.handleDetailModal.bind(this);
        this.handleTestModal = this.handleTestModal.bind(this);

        this.state = {
            loading: false,

            detailModal: false,
            testModal: false,

            channelList: [],
            naverMemberCount: null,
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.messageDetail !== nextProps.messageDetail
            || this.props.messageStat !== nextProps.messageStat
            || this.props.messageModify !== nextProps.messageModify
            || this.props.messageInspect !== nextProps.messageInspect
            || this.state.detailModal !== nextState.detailModal
            || this.state.testModal !== nextState.testModal
            || this.state.naverMemberCount !== nextState.naverMemberCount
            || this.state.loading !== nextState.loading
        )
    }

    componentDidMount() {
        this.ajaxGetSentMessage();
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    /* SKT 반려 사유 파일 다운로드 */
    downloadFile(fileUrl) {
        const anchor = document.createElement('a');
        anchor.setAttribute('download', "SKT 반려 사유");
        anchor.href = fileUrl;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    }

    ajaxGetSentMessage() {
        const { uid } = this.props;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/" + uid,
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                const { SentMessageAction } = this.props;
                SentMessageAction.setMessageDetail(result.info);
                SentMessageAction.setMessageStat(result.stat);
                SentMessageAction.setMessageModify(result.modify);
                SentMessageAction.setMessageInspect(result.inspect);

                this.setState({ channelList: result.info.sendChannel.split(",")})

                if (result.info.naverRedirectUrl) {
                    apiUtil.asyncRequest({
                        url: `/api/bizchat/naver-app/members/count?cmpnId=` + uid,
                        method: apiUtil.requestMethod.GET,
                        success: (countResult) => {
                            this.setState({ naverMemberCount: countResult.count });
                        }
                    });
                }

                if (result.info.approvedMessageId === null && result.info.state === messageUtil.BIZCHAT_STATUS_REQUEST) {
                    alert(
                        "검수가 완료되었습니다." +
                        "\n수정된 문구 확인 후 발송을 희망하지 않을 시 발송 3시간 전까지 발송 취소 버튼을 눌러주세요." +
                        "\n발송 취소 버튼을 누르지 않으면 발송 희망 일자에 맞추어 발송됩니다."
                    );
                }
            }
        })
    }

    ajaxCancelMessageForPackageCmpn() {
        const { messageDetail, uid } = this.props;
        if (!window.confirm("캠페인을 취소하시겠습니까?\n" +
            "* 유효기간 내, 재등록이 가능합니다.(단, 패키지 요금 제 내 생성된 캠페인을 모두 취소 시), 만료기간 내 환불 신청이 가능합니다.( 만료기간 이후 포인트는 소멸)\n" +
            "\n유효 기간 : " + messageDetail.campaignExpireDate +
            "\n만료 기간 : " + messageDetail.canRefundDate +
            "\n-집행이 완료된 캠페인이 있을 경우, 미발송 건수+미발송 회차에 대하여 모든 캠페인 집행 또는 취소 후 일반 포인트로 환급됩니다." +
            "\n-집행이 완료된 캠페인이 없을 경우, 모든 캠페인는 모두 취소 후 환불 신청이 가능합니다.")) return;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/cancel/" + uid + "/package",
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                alert("메시지 발송이 취소되었습니다.");
                window.location.reload();
            }
        });
    }


    ajaxCancelMessage() {
        if (! window.confirm("메시지 발송을 취소하시겠습니까?")) return;

        const { uid } = this.props;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/cancel/" + uid,
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                alert("메시지 발송이 취소되었습니다.");
                window.location.reload();
            }
        })
    }

    ajaxUpdateDeleteFlag() {
        if (! window.confirm("메시지를 삭제하시겠습니까?\n삭제 시에는 복구가 불가능합니다.")) return;

        const { uid } = this.props;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/flagUpdate/" + uid,
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                alert("메시지가 삭제되었습니다.");
                window.location.href = "/sent/list";
            }
        })
    }

    ajaxRefundMessage() {
        if (! window.confirm("포인트를 환급 및 발송 취소 하시겠습니까?")) return;

        const { uid } = this.props;
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/refund/" + uid,
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                alert("포인트를 환급 및 발송 취소 완료되었습니다.");
                window.location.reload();
            }
        })
    }

    handleDetailModal() {
        const { detailModal } = this.state;


        this.setState({ detailModal: ! detailModal })
    }

    handleTestModal() {
        const { testModal } = this.state;
        this.setState({ testModal: ! testModal })
    }

    render() {
        const { loading, } = this.state;
        const  { naverMemberCount } = this.state;

        const { uid, messageDetail, messageStat, messageModify, messageInspect } = this.props;
        const { ajaxCancelMessage, ajaxUpdateDeleteFlag, ajaxRefundMessage, ajaxCancelMessageForPackageCmpn, } = this;

        const { detailModal, testModal, channelList } = this.state;
        const { handleDetailModal, handleTestModal, downloadFile } = this;

        const now = new Date();
        const nowDay = now.toLocaleDateString();

        return (
            <div className='container-xxl'>
                <Loading loading={loading}/>
                <h2 className='fs-4'>상세 정보</h2>
                <div className='card'>
                    <div className='card-body'>
                        <div className='table-responsive'>
                            <table className="table table-bordered">
                                <thead className='table-primary border'>
                                    <tr>
                                        <th colSpan="6">발송 메시지 기본 정보</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th className='w-10'>메시지 명</th>
                                        <td colSpan="2" className='w-40'>{messageDetail.name}</td>
                                        <th className='w-10'>발신 번호</th>
                                        <td colSpan="2" className='w-40'>{stringUtil.formatPhone(messageDetail.callback)}</td>
                                    </tr>
                                    <tr>
                                        <th>메시지 상태</th>
                                        <td colSpan="2">{messageDetail.msgState}</td>
                                        <th className="d-flex align-items-center">
                                            <Tooltip title={"검수는 영업일 기준 2~3일 소요 될 수 있습니다."}>
                                                <div className='d-flex align-items-center pointer'>
                                                    <span>검수 상태</span>
                                                    <span className="material-symbols-rounded ps-1 fs-5 text-primary">info</span>
                                                </div>
                                            </Tooltip>
                                        </th>
                                        <td colSpan="2">{messageDetail.inspectionState}</td>
                                    </tr>
                                    <tr>
                                        <th>메시지 발송 일자</th>
                                        <td colSpan="2">
                                            <ul className="list-unstyled mb-0">
                                                <li>{messageDetail.sndDate}</li>
                                                <li className="text-danger" style={{ fontSize: 10 }}>* 메시지 발송 1시간 이내부터는 발송 취소/수정이 불가능합니다.</li>
                                            </ul>

                                        </td>
                                        <th>메시지 타깃</th>
                                        <td colSpan="2">{stringUtil.formatNumber(messageDetail.sndMosu)} 명</td>
                                    </tr>
                                    <tr>
                                        <th>목표 발송 건수</th>
                                        <td colSpan="2">{stringUtil.formatNumber(messageDetail.sndGoalCnt)} 건</td>
                                        <th>소진 포인트</th>
                                        <td colSpan="2">{stringUtil.formatNumber(messageDetail.budget)} P</td>
                                    </tr>
                                    <tr>
                                        <th>발송 서비스</th>
                                        <td colSpan="2">{messageDetail.sendChannel}</td>
                                        <th>메시지 내용</th>
                                        <td colSpan="2">
                                            <button className='btn btn-sm btn-outline-primary me-2' onClick={handleDetailModal}>메시지 내용 확인하기</button>
                                            {
                                                messageUtil.testSendPossible(messageDetail.state) &&
                                                <button className='btn btn-sm btn-outline-primary' onClick={handleTestModal}>테스트 발송</button>
                                            }
                                        </td>
                                    </tr>
                                    {
                                        messageDetail.naverRedirectUrl &&
                                        <tr>
                                            <th>가입자 수</th>
                                            <td colSpan="5">
                                                {naverMemberCount !== null ? `${naverMemberCount} 명` : '-'}
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>

                        <div className='table-responsive'>
                            <table className="table table-bordered">
                                <thead className='table-primary border'>
                                    <tr>
                                        <th colSpan="12">통계정보 조회</th>
                                    </tr>
                                    <tr className="text-center sub-th">
                                        <th rowSpan="2">통계 기간</th>
                                        <th colSpan="3">발송 수</th>
                                        <th rowSpan="2">
                                            <Tooltip title={"읽음률은 RCS 메시지에서만 제공됩니다."}>
                                                <div className=' align-items-center pointer'>
                                                    <span>읽음수</span>
                                                    <span className="material-symbols-rounded ps-1 fs-5 text-primary">info</span>
                                                </div>
                                            </Tooltip>
                                        </th>
                                        <th rowSpan="2">읽음률</th>
                                        <th rowSpan="2">RCS 반응수</th>
                                        <th rowSpan="2">RCS 반응률</th>
                                        <th rowSpan="2">일반메시지 반응수</th>
                                        <th rowSpan="2">일반메시지 반응률</th>
                                        <th rowSpan="2">총 반응수</th>
                                        <th rowSpan="2">총 반응률</th>
                                    </tr>
                                    <tr  className="text-center sub-th">
                                        <th>RCS</th>
                                        <th>문자메시지</th>
                                        <th>총합</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        messageStat.total ?
                                            <tr>
                                                <td></td>
                                                <td className="text-end">{stringUtil.formatNumber(messageStat.total.rcsMsgRecvCnt)} 건</td>
                                                <td className="text-end">{stringUtil.formatNumber(messageStat.total.vmgMsgRecvCnt)} 건</td>
                                                <td className="text-end">{stringUtil.formatNumber(messageStat.total.msgRecvCnt)} 건</td>
                                                <td className="text-end">{stringUtil.formatNumber(messageStat.total.rcsMsgReadCnt)} 건</td>
                                                <td className="text-end">{stringUtil.formatNumber(messageStat.total.rcsMsgReadRatio)} %</td>
                                                <td className="text-end">{stringUtil.formatNumber(messageStat.total.rcsMsgReactCnt2)}</td>
                                                <td className="text-end">{messageStat.total.rcsMsgReactRatio2}%</td>
                                                <td className="text-end">{stringUtil.formatNumber(messageStat.total.vmgMsgReactCnt2)}</td>
                                                <td className="text-end">{messageStat.total.vmgMsgReactRatio2}%</td>
                                                <td className="text-end">{stringUtil.formatNumber(messageStat.total.msgReactCnt2)}</td>
                                                <td className="text-end">{messageStat.total.msgReactRatio2}%</td>
                                            </tr>
                                            :
                                            <tr>
                                                <td colSpan="12" className="text-center">NO Data</td>
                                            </tr>
                                    }
                                    {
                                        messageStat.details.map((stat, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className="text-center">{stat.day}일</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td className="text-end">{stringUtil.formatNumber(stat.rcsMsgReadCnt)} 건</td>
                                                    <td className="text-end">{stat.rcsMsgReadRatio} %</td>
                                                    <td className="text-end">{stringUtil.formatNumber(stat.rcsMsgReactCnt2)}</td>
                                                    <td className="text-end">{stat.rcsMsgReactRatio2}%</td>
                                                    <td className="text-end">{stringUtil.formatNumber(stat.vmgMsgReactCnt2)}</td>
                                                    <td className="text-end">{stat.vmgMsgReactRatio2}%</td>
                                                    <td className="text-end">{stringUtil.formatNumber(stat.msgReactCnt2)}</td>
                                                    <td className="text-end">{stat.msgReactRatio2}%</td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>

                        <div className='table-responsive'>
                            <table className="table table-bordered">
                                <thead className='table-primary border'>
                                    <tr>
                                        <th colSpan="3">메시지 정보 수정 이력</th>
                                    </tr>
                                    <tr className='sub-th'>
                                        <th>일자</th>
                                        <th>내용</th>
                                        <th>변경자</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    messageModify.length === 0 && <tr><td colSpan="3" className="text-center">NO Data</td></tr>
                                }
                                {
                                    messageModify.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="text-center">{item.modDate}</td>
                                                <td className="text-center">{item.content}</td>
                                                <td className="text-center">{item.modName}</td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                        </div>

                        <div className='table-responsive'>
                            <table className="table table-bordered">
                                <thead className='table-primary border'>
                                    <tr>
                                        <th colSpan="5">메시지 상태 이력</th>
                                    </tr>
                                    <tr className='sub-th'>
                                        <th>일자</th>
                                        <th>내용</th>
                                        <th>비고</th>
                                        <th>파일 보기</th>
                                        <th>담당자</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    messageInspect.length === 0 && <tr><td colSpan="5" className="text-center">NO Data</td></tr>
                                }
                                {
                                    messageInspect.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="text-center">{item.inspectDate}</td>
                                                <td className="text-center">{item.content}</td>
                                                <td className="text-start" style={{ whiteSpace: "pre-wrap" }}>{item.comment}</td>
                                                <td className="text-center">{!(item.commentFile === undefined) && <button className="btn btn-primary" onClick={() => downloadFile(item.commentFile)}>파일 다운로드</button>}</td>
                                                <td className="text-center">{item.inspectName}</td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                        </div>

                        { messageDetail.packageId === null || messageDetail.packageId === undefined ? (
                        <div className='text-center'>
                            {/* state = 0 */}
                            {
                                messageDetail.state === messageUtil.BIZCHAT_STATUS_REGISTERED &&
                                <>
                                    <button className='btn btn-primary btn-md mx-1' onClick={() => window.location.href = "/sent/update/" + uid}>수정</button>
                                    <button className='btn btn-danger btn-md mx-1' onClick={ajaxRefundMessage}>발송 취소</button>
                                </>
                            }

                            {/* state = 9 (추천메시지 내부 승인요청) : 외부 승인요청 전이라 0과 동일하게 삭제(환급) 경로로만 취소 가능 */}
                            {
                                messageDetail.state === messageUtil.BIZCHAT_STATUS_INTERNAL_APPROVE_REQUEST &&
                                <button className='btn btn-danger btn-md mx-1' onClick={ajaxRefundMessage}>발송 취소</button>
                            }

                            {/* state = 17 */}
                            {
                                messageDetail.state === messageUtil.BIZCHAT_STATUS_REJECTED
                                &&
                                <button className="btn btn-warning btn-md mx-1" onClick={ajaxCancelMessage}>포인트 환급</button>
                            }

                            {/* state = 1/2/10/11/20 */}
                            {
                                (
                                    (
                                        messageDetail.state === messageUtil.BIZCHAT_STATUS_REQUEST
                                        || messageDetail.state === messageUtil.BIZCHAT_STATUS_GOUN_REQUEST
                                        || messageDetail.state === messageUtil.BIZCHAT_STATUS_GOUN_APPROVED
                                        || messageDetail.state === messageUtil.BIZCHAT_STATUS_APPROVED
                                        || messageDetail.state === messageUtil.BIZCHAT_STATUS_READY
                                    )
                                    && dateUtil.isMoreThanOneHour(messageDetail.sndDate)
                                )
                                &&
                                <button className='btn btn-danger btn-md mx-1' onClick={ajaxCancelMessage}>발송 취소</button>
                            }

                            {/* state = 25 OR state = 40 */}
                            {
                                messageDetail.state === messageUtil.BIZCHAT_STATUS_CANCEL &&
                                <button className="btn btn-warning btn-md mx-1" onClick={ajaxUpdateDeleteFlag}>삭제</button>
                            }

                            <button className={"btn btn-secondary btn-md mx-1"} onClick={() => window.location.href = "/sent/list"}>목록</button>
                        </div>
                            ) : (
                        <div className='text-center'>
                            {/* 패키지 캠페인 등록 state = 0 */}
                            {
                                messageDetail.isFirstPackageCmpn && messageDetail.state === messageUtil.BIZCHAT_STATUS_REGISTERED  &&
                                <>
                                    {/*<button className='btn btn-primary btn-md mx-1' hidden={messageDetail.campaignExpireDate > nowDay} onClick={() => window.location.href = "/sent/update/" + uid}>수정</button>*/}
                                    <button className='btn btn-danger btn-md mx-1' onClick={() => ajaxCancelMessageForPackageCmpn()}>발송 취소</button>
                                </>
                            }

                            {/* 패키지 첫 캠페인 state = 1, 2, 10, 17 */}
                            {
                                messageDetail.isFirstPackageCmpn && (
                                    messageDetail.state === messageUtil.BIZCHAT_STATUS_GOUN_REQUEST
                                    || messageDetail.state === messageUtil.BIZCHAT_STATUS_GOUN_APPROVED
                                    || messageDetail.state === messageUtil.BIZCHAT_STATUS_REQUEST
                                    || messageDetail.state === messageUtil.BIZCHAT_STATUS_REJECTED) &&
                                <>
                                    <button className='btn btn-danger btn-md mx-1' onClick={() => ajaxCancelMessageForPackageCmpn()}>발송 취소</button>
                                </>
                            }

                            {/* 패키지 첫 캠페인 state = 11, 20 or 패키지 캠페인 state = 10, 11, 20, 17*/}
                            {
                                ((messageDetail.isFirstPackageCmpn === false && (messageDetail.state === messageUtil.BIZCHAT_STATUS_REQUEST
                                                                        || messageDetail.state === messageUtil.BIZCHAT_STATUS_REJECTED ))
                                    || messageDetail.state === messageUtil.BIZCHAT_STATUS_APPROVED
                                    || messageDetail.state === messageUtil.BIZCHAT_STATUS_READY)  &&
                                <>
                                    <button className='btn btn-danger btn-md mx-1' onClick={() => ajaxCancelMessageForPackageCmpn()}>발송 취소</button>
                                </>
                            }

                            {/* state = 25 OR state = 40 */}
                            {
                                messageDetail.state === messageUtil.BIZCHAT_STATUS_CANCEL &&
                                <button className="btn btn-warning btn-md mx-1" onClick={ajaxUpdateDeleteFlag}>삭제</button>
                            }

                            <button className={"btn btn-secondary btn-md mx-1"} onClick={() => window.location.href = "/sent/list"}>목록</button>
                        </div>
                            )
                        }
                    </div>
                </div>

                <MessageDetailModal isOpen={detailModal} onClose={handleDetailModal} channelList={channelList} cmpnUid={uid}/>
                {
                    messageUtil.testSendPossible(messageDetail.state) &&
                    <MessageTestModal isOpen={testModal} onClose={handleTestModal} cmpnUid={uid}/>
                }
            </div>
        )
    }
}

export default connect(
    (state) => ({
        messageDetail: state.sentMessage.get('messageDetail'),
        messageStat: state.sentMessage.get('messageStat'),
        messageModify: state.sentMessage.get('messageModify'),
        messageInspect: state.sentMessage.get('messageInspect'),
    }),
    (dispatch) => ({
        SentMessageAction: bindActionCreators(sentMessageAction, dispatch),
    })
)(SentDetailContainer);
